/**
 * Makes the (now visible-at-desktop, see funkissd-overrides-v2.css) main
 * product image slider's prev/next arrows advance the active image
 * directly, instead of relying on Dawn's SliderComponent scroll behavior.
 *
 * Why: Dawn's generic SliderComponent (assets/global.js) drives the
 * prev/next buttons in snippets/product-media-gallery.liquid purely by
 * scrolling the <ul class="product__media-list ... slider--mobile">. That
 * works fine on mobile, but at desktop widths (>=750px) with our
 * "thumbnail" gallery_layout, that <ul> isn't horizontally scrollable at
 * all - switching the visible image instead happens by the <media-gallery>
 * custom element (assets/media-gallery.js) toggling an "is-active" class,
 * the same way clicking a thumbnail does. So on desktop the stock arrows
 * would be visually present but functionally inert.
 *
 * This listens for clicks on the specific slider-buttons bar that sits
 * immediately after the main gallery's <ul>, works out the next/previous
 * media item in DOM order (looping at either end), and calls the same
 * public setActiveMedia(mediaId, prepend) method the thumbnail buttons use.
 */
(function () {
  function findGalleryArrowButton(target) {
    var btn = target.closest('.slider-button');
    if (!btn) return null;

    var wrapper = btn.closest('.slider-buttons');
    if (!wrapper) return null;

    var prevSibling = wrapper.previousElementSibling;
    if (!prevSibling || !prevSibling.classList.contains('product__media-list')) return null;

    return btn;
  }

  document.addEventListener('click', function (event) {
    var btn = findGalleryArrowButton(event.target);
    if (!btn) return;

    var gallery = btn.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var list = gallery.querySelector('ul.product__media-list');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('li[data-media-id]'));
    if (!items.length) return;

    var currentIndex = items.findIndex(function (li) {
      return li.classList.contains('is-active');
    });
    if (currentIndex === -1) currentIndex = 0;

    var direction = btn.classList.contains('slider-button--next') ? 1 : -1;
    var nextIndex = (currentIndex + direction + items.length) % items.length;
    var targetItem = items[nextIndex];

    if (targetItem && targetItem.dataset.mediaId) {
      event.preventDefault();
      gallery.setActiveMedia(targetItem.dataset.mediaId, false);
    }
  });
})();
